<template>
  <div
    v-if="list.length && mode === 'runtime'"
    id="xy-client-hmr-page-list"
  >
    <div class="debug-tips">
      {{ $t("k_f4da8ef") }}
    </div>
    <a-select
      v-model="id"
      :allow-clear="true"
      class="page-selection"
      :placeholder="$t('k_5542def7')"
    >
      <a-select-option
        v-for="page in list"
        :key="page.sourceCodeConfig.id"
        :value="page.sourceCodeConfig.id"
        @dropdownVisibleChange="$event && loadList()"
      >
        {{ page.name || page.sourceCodeConfig.id }}
        <a-tooltip
          v-if="!page.path"
          placement="rightTop"
        >
          <template slot="title">
            <span>{{ $t("k_86cb51ae") }}</span>
          </template>
          <a-icon type="warning" />
        </a-tooltip>
      </a-select-option>
    </a-select>
  </div>
</template>

<script>
import { $t } from '@/i18n';
import { message } from '@utils/wuji-message';
import pageLoader from '@loaders/page/loader';
import { getRouterPublicParams } from '@utils/routerPublicParams';

export default {
  props: {
    mode: {
      type: String,
      default: 'editor', // 'editor'(编辑时) | 'runtime'(运行时)
    },
    projectId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      list: [],
      id: undefined,
    };
  },
  async created() {
    await this.loadList();

    this.$watch(() => this.id, () => {
      if (this.id === undefined) return;
      this.onRoute(this.id);
    });

    this.$watch(() => this.$route, () => {
      const { path } = this.$route;
      let exist = false;
      this.list.forEach((item) => {
        if (item.path === path) {
          this.id = item.sourceCodeConfig.id;
          exist = true;
        }
      });

      if (!exist) {
        this.id = undefined;
      }
    }, { immediate: true });

    this.$watch(() => this.projectId, async () => {
      this.loadList();
    });
  },
  methods: {
    async loadList() {
      if (!this.projectId) return;

      try {
        this.list = await pageLoader.loadDebugList(this.projectId);
      } catch (err) {
        message.error($t('k_ec16344c'));
      }
    },
    onRoute(id) {
      const pageInfo = this.list.find(page => page.sourceCodeConfig.id === id);
      if (pageInfo && pageInfo.path) {
        this.$router.push({
          path: pageInfo.path,
          query: {
            ...this.$route.query,
            ...getRouterPublicParams(this.$route.query),
          },
        });
      } else {
        message.info($t('k_e6214383'));
      }
    },
  },
};
</script>

<style lang="scss">
#xy-client-hmr-page-list{
  .page-selection {
    width: 100px;
  }
  .debug-tips {
    margin-right: 5px;
    margin-left: 10px;
    display: inline;
    font-size: 14px;
    color: var(--wuji-primary-color);
  }
}
</style>
